module.exports = __webpack_public_path__ + "img/H14-1.png";